import { memo } from "react";

export const StylusIcon = memo(() => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.17424 18C1.82424 18.0833 1.52007 17.9958 1.26174 17.7375C1.0034 17.4792 0.915904 17.175 0.999238 16.825L1.99924 12.05L6.94924 17L2.17424 18ZM6.94924 17L1.99924 12.05L13.4492 0.600002C13.8326 0.216668 14.3076 0.0250015 14.8742 0.0250015C15.4409 0.0250015 15.9159 0.216668 16.2992 0.600002L18.3992 2.7C18.7826 3.08333 18.9742 3.55833 18.9742 4.125C18.9742 4.69167 18.7826 5.16667 18.3992 5.55L6.94924 17ZM14.8742 2L4.52424 12.35L6.64924 14.475L16.9992 4.125L14.8742 2Z"
        fill="#878787"
      />
    </svg>
  );
});
